import React, {Component} from 'react';

class LoadingComponent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,
		}
	}

	enLoading = () => this.setState({ isLoading: true });
	unLoading = () => this.setState({ isLoading: false });
}

export default LoadingComponent;
